import React from 'react';
import { Theme } from '@mui/material/styles';
import { createStyles, makeStyles } from '@mui/styles';
import { Alert } from '@mui/material';
import IconButton from "@mui/material/IconButton";
import Collapse from "@mui/material/Collapse";
import CloseIcon from "@mui/icons-material/Close";
import classnames from 'classnames';

// Contexts
import { withTranslate } from '../../../core/TenantProvider';
// Files in the same folder
import { ReactComponent as WarningIcon } from "./assets/icons/warningIcon.svg";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      backgroundColor: '#ffffff',
      margin: "auto",
      boxShadow: "0px 1px 4px rgba(0, 0, 0, 0.08)",
      [theme.breakpoints.up('md')]: {
        maxWidth: 870,
        marginBottom: 32
      },
      [theme.breakpoints.down('lg')]: {
        width: 560,
        marginBottom: 32
      },
      [theme.breakpoints.down('md')]: {
        width: "90%",
        marginBottom: 32
      },
      "& .MuiCollapse-container": {
        margin: "20px auto 44px",
        [theme.breakpoints.down('md')]: {
          margin: "0 auto 20px"
        },
        "&.MuiCollapse-hidden": {
          margin: "0 auto 0",
        }
      },
      "& .MuiCollapse-wrapperInner": {
        [theme.breakpoints.down('lg')]: {
          margin: "0"
        },
        [theme.breakpoints.down('md')]: {
          margin: "0"
        },

        "& .MuiAlert-outlinedError": {
          border: "none",
          justifyContent: 'center',
          "& .MuiAlert-icon": {
            margin: "5px 6px 0 0",
          },
          "& .MuiAlert-action": {
            [theme.breakpoints.up('md')]: {
              marginLeft: "0",
            },
            [theme.breakpoints.down('md')]: {
              position: "relative",
              top: "-15px",
              margin: "0",
              marginLeft: "auto"
            },
          },
          "& .MuiAlert-message": {
            fontSize: "16px",
            padding: "13px 0",
            color: "#4A4A4A",
            "& a": {
              color: "#2d91e9",
              textDecoration: 'none'
            },
          },
          "& .MuiSvgIcon-fontSizeInherit": {
            fontSize: "20px"
          },
        },
      },
    },
    boldFont: {
      [theme.breakpoints.down('md')]: {
        display: "block"
      }
    },
    copy: {
      [theme.breakpoints.down('md')]: {
        marginLeft: "0",
        marginTop: 2,
        display: 'block',
      }
    }
  })
);

const ErrorMessage = (props: any) => {
  const classes = useStyles();
  const [open, setOpen] = React.useState<boolean>(true);
  const { className, onClose, translate, errorMessage, linkMessage, link, hasLink } = props;

  return (
    <div className={open ? classnames(className, classes.root) : ''}>
      <Collapse in={open}>
        <Alert
          role="alert"
          iconMapping={{ warning: <WarningIcon fontSize="inherit" /> }}
          variant="outlined"
          severity="error"
          action={
            <IconButton
              data-testid='errormsg'
              aria-label="close"
              color="inherit"
              size="small"
              onClick={(e) => {
                setOpen(false);
                onClose && onClose(e);
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          }
        >
          <strong className={classes.boldFont}>{translate('notifications.heading.error')} &nbsp;</strong>
          <span className={classes.copy}>{errorMessage}</span>
          {hasLink && (<a href={link}>{linkMessage}</a>)}
        </Alert>
      </Collapse>
    </div>
  );
}

export default withTranslate(
  (ErrorMessage)
);